(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductCustomization extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.input = this.querySelector('input[name="properties[Personalization]"]');
    this.form = this.input ? this.input.form : null;
    this.counter = this.querySelector('[data-char-counter]');
    this.errorEl = this.querySelector('[data-personalization-error]');
    this.textField = this.querySelector('[data-text-field]');
    this.nested = this.querySelector('.nested-cart-item');

    this.querySelectorAll('input[type="radio"]').forEach((radio) => {
      radio.addEventListener('change', this.onRadioChange.bind(this));
    });

    // Mobile toggle (free-personalization products only): on = personalize, off = none
    this.mobileToggle = this.querySelector('[data-mobile-toggle]');
    if (this.mobileToggle) {
      const checkedType = this.querySelector('input[name="_personalization_type"]:checked');
      this.mobileToggle.checked = !(checkedType && checkedType.value === 'none');
      this.mobileToggle.addEventListener('change', this.onMobileToggle.bind(this));
    }

    if (this.input) {
      this.input.addEventListener('input', this.onInput.bind(this));
    }
    if (this.form) {
      this.form.setAttribute('novalidate', 'novalidate');
      if (this.input && this.input.hasAttribute('required')) this.input.removeAttribute('required');
      this.form.addEventListener('submit', this.onSubmit.bind(this), true);
      // Also validate on the add-to-cart click (capture) so we block before the
      // AJAX submit handler runs, regardless of listener registration order.
      const addBtn = this.form.querySelector('[name="add"]');
      if (addBtn) addBtn.addEventListener('click', this.onSubmit.bind(this), true);
    }

    const checked = this.querySelector('input[name="_personalization_type"]:checked');
    if (checked) this.applyType(checked.value, parseInt(checked.dataset.limit || '0', 10));
    this.syncName('properties[Font]', '[data-selected-font]');
    this.syncName('properties[Color]', '[data-selected-color]');
  }

  onRadioChange(e) {
    const name = e.currentTarget.name;
    if (name === '_personalization_type') {
      this.applyType(e.currentTarget.value, parseInt(e.currentTarget.dataset.limit || '0', 10));
      this.hideError();
    } else if (name === 'properties[Font]') {
      this.syncName('properties[Font]', '[data-selected-font]');
    } else if (name === 'properties[Color]') {
      this.syncName('properties[Color]', '[data-selected-color]');
    }
  }

  onMobileToggle() {
    let target;
    if (this.mobileToggle.checked) {
      target = this.querySelector('input[name="_personalization_type"]:not([value="none"]):not([disabled])');
    } else {
      target = this.querySelector('input[name="_personalization_type"][value="none"]');
    }
    if (target) {
      target.checked = true;
      target.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  applyType(value, limit) {
    const isEmbroid = value === 'embroid';
    const isNone = value === 'none';

    if (this.textField) this.textField.style.display = isNone ? 'none' : 'block';
    // Keep the Personalization property enabled even when "none" is chosen so the
    // cart still records the choice as "[Don't Personalize]", matching the old theme.
    if (this.input) {
      this.input.disabled = false;
      if (isNone) {
        this.input.value = "[Don't Personalize]";
      } else if (this.input.value === "[Don't Personalize]") {
        this.input.value = '';
      }
    }

    this.querySelectorAll('[data-embroidery-field]').forEach((el) => {
      el.style.display = isEmbroid ? 'block' : 'none';
    });
    this.querySelectorAll('input[name="properties[Font]"], input[name="properties[Color]"]').forEach((i) => {
      i.disabled = !isEmbroid;
    });

    if (this.nested) this.nested.disabled = !isEmbroid;

    if (!isNone && this.input) {
      this.input.setAttribute('maxlength', limit);
      if (this.input.value.length > limit) this.input.value = this.input.value.substring(0, limit);
      this.updateCounter();
    }

    if (isNone) this.hideError();
  }

  onInput() {
    this.updateCounter();
    if (this.input && this.input.value.trim()) this.hideError();
  }

  updateCounter() {
    if (!this.counter || !this.input) return;
    const limit = parseInt(this.input.getAttribute('maxlength') || '0', 10);
    this.counter.textContent = this.input.value.length + '/' + limit;
  }

  syncName(inputName, targetSelector) {
    const radio = this.querySelector('input[name="' + inputName + '"]:checked');
    const target = this.querySelector(targetSelector);
    if (radio && target) target.textContent = radio.dataset.name || radio.value;
  }

  isActive() {
    const checked = this.querySelector('input[name="_personalization_type"]:checked');
    return checked && checked.value !== 'none';
  }
  showError() {
    if (this.input) this.input.classList.add('has-error');
    if (this.errorEl) this.errorEl.hidden = false;
  }
  hideError() {
    if (this.input) this.input.classList.remove('has-error');
    if (this.errorEl) this.errorEl.hidden = true;
  }
  onSubmit(e) {
    if (this.isActive() && this.input && !this.input.value.trim()) {
      e.preventDefault();
      e.stopImmediatePropagation();
      this.showError();
      this.input.focus();
    }
  }
}
if (!window.customElements.get('product-customization')) {
  window.customElements.define('product-customization', ProductCustomization);
}

  } catch(e) { console.error(e); }
})();
})();
